import { useDeviceType } from "@/common/hooks/useDeviceType";
import { deviceTypeEnum } from "@/common/utils/device";
import { useLocation } from "react-router-dom";
import { routes } from "@/common/utils/routes";
import { UploadHeader } from "components/header/UploadHeader";

import "./ApplicationHeader.scss";
import { useLessNavigation } from "@/common/hooks/useLessNavigation";
import { useAppStore } from "@/common/store/appStore";
import { MainHeader } from "../MainHeader";
import { MainHeaderV2 } from "../MainHeaderV2";
import { useFeedStore } from "@/common/store/useFeedStore";
import { clsx } from "clsx";

export const ApplicationHeader = () => {
  const location = useLocation();
  const deviceType = useDeviceType();
  const isDesktop = deviceType === deviceTypeEnum.DESKTOP;
  const { canShow } = useLessNavigation();
  const isSearchBarOpen = useAppStore((state) => state.isSearchBarOpen);
  const isBurgerMenuOpen = useAppStore((state) => state.isBurgerMenuOpen);
  const isProfileMenuOpen = useAppStore((state) => state.isProfileMenuOpen);
  const isV2HeaderEnabled = useFeedStore((state) => state.isV2HeaderEnabled);
  const isV2HeaderVisible = useFeedStore((state) => state.isV2HeaderVisible);

  if (!canShow) {
    return null;
  }

  const showUploadHeader = location.pathname.includes(routes.create()) && !isDesktop;

  return (
    <div className={clsx(
      "topNav",
      isV2HeaderEnabled && "topNavV2",
      isSearchBarOpen && "activeSearch",
      isProfileMenuOpen && "activeProfileMenu",
      isBurgerMenuOpen && "activeBurgerMenu",
      !isV2HeaderVisible && "hiddenV2Header"
    )}>
      {showUploadHeader ? (
        <UploadHeader />
      ) : (
        isV2HeaderEnabled ? <MainHeaderV2 /> : <MainHeader />
      )}
    </div>
  );
};
